import { axios } from '../utilities';

const getPricesOfPackages = () => axios.get('api/prices');

const updatePricesOfPackages = prices => axios.put('api/prices', { prices });

export default {
  getPricesOfPackages,
  updatePricesOfPackages,
};
